import styled from 'styled-components';

interface Props {
  onClose: () => void;
  search_category: string[];
}

function ThemeModal({ onClose, search_category }: Props) {
  return (
    <ModalOverlay
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClose();
      }}
    >
      <ModalContainer
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Header>
          <span>해당 물건 퀀트 테마</span>
          <img
            src="/assets/images/close/close_black.svg"
            alt="close"
            onClick={onClose}
            width={24}
            height={24}
          />
        </Header>
        <BadgeWrapper>
          {search_category.map((themeName) => (
            <ThemeBadge key={themeName}>{themeName}</ThemeBadge>
          ))}
        </BadgeWrapper>
        <Button onClick={onClose}>닫기</Button>
      </ModalContainer>
    </ModalOverlay>
  );
}

export default ThemeModal;

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #00000085;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalContainer = styled.div`
  width: 328px;
  background-color: #ffffff;
  overflow: hidden;
  box-shadow: 0px 4px 15px 0px #8d95a340;
  padding: 20px;
  border-radius: 20px;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 16px;

  font-weight: 700;
  font-size: 16px;

  img {
    cursor: pointer;
  }
`;

const BadgeWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-bottom: 16px;
  flex-wrap: wrap;
`;

const ThemeBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9999px;
  padding: 2px 8px;
  width: fit-content;
  background: #d224ca;
  border: none;

  font-weight: 700;
  font-size: 12px;
  color: #ffffff;
`;

const Button = styled.button`
  width: 100%;
  border-radius: 8px;
  padding: 12px 24px;
  background: #70737c14;
  border: none;
  cursor: pointer;

  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #616161;
`;
